import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

export interface RoundedImageProps {
  $size: '25px' | '50px' | '100px' | '150px' | '200px';
}

export const RoundedImage = styled(GatsbyImage)<RoundedImageProps>`
  border-radius: 100%;
  width: ${(props): string => props.$size};
  height: ${(props): string => props.$size};
  transform: translateZ(0);
  flex-shrink: 0;
`;
